/**
 * Top-level SSE lifecycle hook for the web's notification page.
 *
 * Mounts the SSE pipeline once on first render after pairing
 * confirms, tears it down on unmount. Anything that needs the live
 * `notifications` / `conversations` arrays should still subscribe
 * via the existing `useStorage` hook — this hook only owns the
 * IO side.
 */

import { useEffect } from "react";
import { startNotificationsStream } from "../services/sse";

export function useNotificationsStream(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    const lifecycle = startNotificationsStream();
    return () => lifecycle.stop();
  }, [enabled]);
}
